import { useExperiments } from '@wix/fe-essentials-standalone';
import { useContext, useEffect, useState } from 'react';

import { EXPERIMENTS } from '../constants';
import { useWindowSize } from './useWindowSize';
import { Context } from '../context';
import { isMobile, isTablet } from '../utils/userAgent';

const useIsHelpCenterCopilotEnabled = () => {
  const context = useContext(Context);
  const [isMobileView, setIsMobileView] = useState(context.isMobile);
  const [isTabletView, setIsTabletView] = useState(context.isTablet);
  const windowSize = useWindowSize();
  const { experiments } = useExperiments({ suspense: false, readOnly: true });

  useEffect(() => {
    if (windowSize.width) {
      setIsMobileView(isMobile(context));
      setIsTabletView(isTablet(context));
    }
  }, [context, windowSize.width]);

  return experiments.enabled(EXPERIMENTS.SPECS.HELP_CENTER_COPILOT) && !isMobileView && !isTabletView;
};

export default useIsHelpCenterCopilotEnabled;
